function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlob2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "-37.6 37.7 1028.6 821.9",
    zoomAndPan: "magnify",
    style: {
      fill: "rgb(0, 0, 0)"
    },
    original_string_length: 531,
    width: "1029px",
    height: "822px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "__id0_stpft18sf8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 793.179688 340.71875 C 742.148438 225.269531 633.117188 37.679688 325.628906 150.152344 C 18.136719 262.625 -37.578125 326.777344 125.589844 593.183594 C 288.761719 859.585938 990.976562 788.175781 793.179688 340.71875",
    style: {
      fill: "rgb(166, 166, 166)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob2);
export default __webpack_public_path__ + "static/media/blob2.812cc812dfa29786bd08f3fb1171e4f8.svg";
export { ForwardRef as ReactComponent };